import { Action, Reducer } from "redux";
import { InsurerTypes, InsurerState, InsurerActionTypes } from "./insurerTypes";
import { haskeyReducer } from "@/main/services/reducerUtils";

export const INITIAL_STATE: InsurerState = {
	insurers: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	insurersPublic: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	insurersFull: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	usersByInsurerFull: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const insurerReducer: Reducer<InsurerState> = (state: InsurerState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as InsurerActionTypes;

	switch (actionTypes.type) {
		case InsurerTypes.GET_INSURERS: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) {
				return {
					...state,
					isolated: {
						...state.isolated,
						[actionTypes.payload.keyReducer]: {
							...(state.isolated[actionTypes.payload.keyReducer] ?? INITIAL_STATE.insurers),
							isLoading: true,
						},
					},
				};
			}

			return {
				...state,
				insurers: { ...state.insurers, isLoading: true },
			};
		}
		case InsurerTypes.SAVE_INSURERS: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) {
				return {
					...state,
					isolated: {
						...state.isolated,
						[actionTypes.payload.keyReducer]: {
							...state.isolated[actionTypes.payload.keyReducer],
							isLoading: false,
							errorMessages: actionTypes.payload.errorMessages,
							isError: actionTypes.payload.isError,
							data: actionTypes.payload.data,
						},
					},
				};
			}
			return {
				...state,
				insurers: {
					...state.insurers,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case InsurerTypes.GET_INSURERS_PUBLIC:
			return {
				...state,
				insurersPublic: {
					...state.insurersPublic,
					isLoading: true,
				},
			};
		case InsurerTypes.SAVE_INSURERS_PUBLIC:
			return {
				...state,
				insurersPublic: {
					...state.insurersPublic,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case InsurerTypes.RESET_REDUCER_INSURERS:
			return {
				...state,
				insurers: INITIAL_STATE.insurers,
			};
		case InsurerTypes.GET_INSURERS_FULL:
			return {
				...state,
				insurersFull: { ...state.insurersFull, isLoading: true },
			};
		case InsurerTypes.SAVE_INSURERS_FULL:
			return {
				...state,
				insurersFull: {
					...state.insurersFull,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case InsurerTypes.GET_INSURERS_USERS_BY_INSURER:
			return {
				...state,
				usersByInsurerFull: { ...state.usersByInsurerFull, isLoading: true },
			};
		case InsurerTypes.SAVE_INSURERS_USERS_BY_INSURER:
			return {
				...state,
				usersByInsurerFull: {
					...state.usersByInsurerFull,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case InsurerTypes.RESET_REDUCER_INSURERS_FULL:
			return {
				...state,
				insurersFull: INITIAL_STATE.insurersFull,
				usersByInsurerFull: INITIAL_STATE.usersByInsurerFull,
			};
		default:
			return state;
	}
};

export default insurerReducer;
